module.exports = __webpack_public_path__ + "fonts/HKGrotesk-Italic.89be236.woff2";